





























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Form } from '@ss/mtd-vue';
import * as api from '@/api';
import { get } from 'lodash';
import * as validators from '@/utils/validator';
@Component({})
export default class CatalogModal extends Vue {
    @Prop()
    level: number;
    @Prop({ required: true })
    show: boolean;
    @Prop()
    id: number;
    @Prop()
    name: string;

    @Watch('show')
    handleModalVisible() {
        this.newCatalog = !this.newCatalog;
    }

    formCustom: any = {
        parentName: '',
        name: '',
        rgId: null
    };
    newCatalog: boolean = false;
    loading: boolean = false;
    ruleCustom: any = {
        name: {
            validator: validators.validateName100,
            required: true
        },
        rgId: {
            required: true,
            message: 'RG不能为空'
        }
    };
    options: any = [];

    created() {
        this.remoteMethod('');
    }

    resetForm() {
        (this.$refs.formCustom as Form).resetFields();
    }

    closeModal() {
        this.newCatalog = !this.newCatalog;
    }

    async validateForm() {
        return new Promise((resolve, reject) => {
            (this.$refs.formCustom as Form)
                .validate(valid => {
                    if (valid) {
                        resolve('ok');
                    } else {
                        const e = new Error('校验未通过');
                        reject(e);
                    }
                })
                .catch(e => e);
        }).catch();
    }

    async createTree() {
        const v = await this.validateForm();
        if (v === 'ok') {
            this.$emit('updateTree', this.formCustom, this.level, this.id);
            this.resetForm();
        }
    }

    async remoteMethod(query) {
        const spaceId = parseInt(this.$route.params.id, 10);
        const res = await api.ctiApi.getAllSpaceRg({
            spaceId,
            name: query
        });
        this.options = get(res, ['data', 'items']);
    }
}
